// extracted by mini-css-extract-plugin
module.exports = {"elons":"Elon_elons__36LM1","elonScrol":"Elon_elonScrol__2Q5_N","card":"Elon_card__39fOS","card-body":"Elon_card-body__1Ng9L","card-title":"Elon_card-title__1NosH"};